// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MM_cmp_root = require("./metamath/ui/MM_cmp_root.bs.js");
var Expln_React_ViewSelector = require("@expln/utils/src/main/Expln_React_ViewSelector.bs.js");

function MainView(Props) {
  return React.createElement(Expln_React_ViewSelector.make, {
              allViews: [{
                  id: "1",
                  title: "MM_cmp_root",
                  render: (function (param) {
                      return React.createElement(MM_cmp_root.make, {});
                    })
                }],
              defaultViewId: "1"
            });
}

var make = MainView;

exports.make = make;
/* react Not a pure module */
